import { processHistorical } from "@/_core/data/api_calls/relatives_values/historical/processHistorical";

/**
 * Retrieves historical data for currency relative values.
 * @param {object} ctx - Context variables containing currency data.
 * @returns {Promise} - A promise that resolves to the historical data for currencies.
 */
export function getHistCurrencies(ctx) {
  // Define the parameters for the GET request
  let params = {
    method: "GET", // HTTP method for the request
    endpoint: "relatives_values_historical", // API endpoint to fetch historical relative values
    content_type: "application/json", // Content type for the request
    query_params: {
      format: "json", // Ensure the response is in JSON format
      currency: ctx.currencyNumber, // Currency number from the context
      correlations: false // Exclude correlation data
    }
  };
  // Process and return the historical data by calling the processHistorical function
  return processHistorical(ctx, params);
}
